var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99981 6.31345C5.14364 6.31345 5.28747 6.25593 5.3853 6.14662L9.84429 1.58406C9.94209 1.48626 9.99963 1.35969 9.99963 1.21583C9.99963 0.916664 9.76949 0.686523 9.47029 0.686523C9.33221 0.686523 9.19412 0.744064 9.09632 0.836096L4.99981 5.02466L0.903306 0.836096C0.805481 0.744064 0.673165 0.686523 0.529336 0.686523C0.230141 0.686523 0 0.916664 0 1.21583C0 1.35969 0.0575414 1.48626 0.155342 1.58981L4.61433 6.14662C4.72365 6.25593 4.85022 6.31345 4.99981 6.31345Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.0d46ba4923e1d79f3c16607115849285.svg";
export { ForwardRef as ReactComponent };